import React from 'react';
import LandingNavbar from '../pages/Landing/ForecastNestHome/navbar';
import LandingFooter from '../pages/Landing/ForecastNestHome/footer';

/**
 * The site's header and footer, for a public page that does not draw its own.
 *
 * Most do: the policy pages render them directly, the sign-in screens get them
 * through ParticlesAuth, and OpenLayout supplies them for a signed-out visitor
 * on a shared forecast. What was left over were the error screens — 404, 500,
 * offline — which had no header and no footer at all.
 *
 * Those are not template curiosities. A 404 is the page a real visitor lands on
 * when a link is wrong, which is precisely the moment they need a way back into
 * the site, and it is where a search engine sends anyone following a stale
 * result.
 *
 * Applied per route rather than inside NonAuthLayout on purpose: 30 of the 36
 * public routes already bring their own chrome, and a wrapper that could not
 * tell the difference would draw a second navbar on every one of them.
 */
const PublicChrome = ({ children }) => (
  <div className="layout-wrapper landing">
    <LandingNavbar />
    {children}
    <LandingFooter />
  </div>
);

export default PublicChrome;
